import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchCenterInitiatedRepatriationsTransactionsCreate from '../../api/CenterInitiatedRepatriationsTransactionsCreateAPI';
import { CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST } from '../actions/types/CenterInitiatedRepatriationsTransactionsCreateActionsTypes';
import {
  postCenterInitiatedRepatriationsTransactionsCreateSuccessActionCreator,
  postCenterInitiatedRepatriationsTransactionsCreateFailureActionCreator,
} from '../actions/CenterInitiatedRepatriationsTransactionsCreateActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doCenterInitiatedRepatriationsTransactionsCreateWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchCenterInitiatedRepatriationsTransactionsCreate, action.payload);
    yield put(postCenterInitiatedRepatriationsTransactionsCreateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.centerinitiatedrepatriationstransactions.create.success'),
    }));
  } catch (error) {
    yield put(postCenterInitiatedRepatriationsTransactionsCreateFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.centerinitiatedrepatriationstransactions.create.failure'),
    }));
  }
}

function* doCenterInitiatedRepatriationsTransactionsCreateWatcher() {
  yield takeLatest(CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST, doCenterInitiatedRepatriationsTransactionsCreateWorker);
}

export default doCenterInitiatedRepatriationsTransactionsCreateWatcher;
